import { createContext, useContext } from 'react';
import { TableProviderProps, Values } from '../types';

// Sometimes we need to use "any"
// eslint-disable-next-line
const TableContext = createContext<Values<any> | null>(null);

export const TableProvider = <T,>({ children, value }: TableProviderProps<T>) => {
  return <TableContext.Provider value={value}>{children}</TableContext.Provider>;
};

function useTableContext<T>() {
  const context = useContext(TableContext);
  if (context === null) {
    throw new Error('useTableContext must be used within a TableProvider');
  }
  return context as Values<T>;
}

export { useTableContext };
